import classNames from "classnames"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"
import styles from "./FeedItemContent.module.scss"

export type Props = ComponentPropsWithoutRef<"button">

export const FeedItemContent = forwardRef<HTMLButtonElement, Props>(
  function FeedItemContent(props: Props, ref: Ref<HTMLButtonElement>) {
    const className = classNames(
      styles.feedItemContent,
      props.className,
    )

    return (
      <button
        {...props}
        className={className}
        ref={ref}
      />
    )
  },
)
